import React, { useEffect, useState } from "react";
import { Container, Row, Col, Label, Input, FormGroup, Nav, NavItem, NavLink, TabContent, TabPane ,Spinner, Card } from "reactstrap";
import axios from "axios";
import { BACKEND_URL_LOG, BACKEND_URL_PORTAIL ,BACKEND_URL_DOC} from "../../config/const.js";
import { useTranslation } from 'react-i18next';
import classnames from "classnames";
import './style.css';
import ListLogs from './ListLogs.js';
import ReadingList from "./ReadingList.js";
import QuizList from "./QuizList.js";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { fr, enUS } from "date-fns/locale";


const Dashboard = () => {
   const { t } = useTranslation();
 document.title = t('DashboardQUESSPortail');
  const navigate = useNavigate();
  const [dataStat, setDataStat] = useState([]);
  const [dataStatDoc, setDataStatDoc] = useState([]);
  const [currentOrg, setCurrentOrg] = useState(localStorage.getItem("currentOrg"));
  const [type, setType] = useState(localStorage.getItem("type")||"all");
  const [orgName, setOrgName] = useState("");
  const today = new Date().toISOString().split("T")[0];
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [preset, setPreset] = useState("");
  const [shouldCheckInterval, setShouldCheckInterval] = useState(true);
  const [userConnected, setUserConnected] = useState(JSON.parse(localStorage.getItem("user")) || []);
  const [allCleanrooms, setAllCleanrooms] = useState(JSON.parse(localStorage.getItem("allCleanrooms")) || []);
  const [open, setOpen] = useState(false);
  const [openReadingList, setOpenReadingList] = useState(false);
  const [openQuizList, setOpenQuizList] = useState(false);
  const [typeDetail, setTypeDetail] = useState("");
  const [typeReadingList, setTypeReadingList] = useState("");
  const [typeQuizList, setTypeQuizList] = useState("");
  const [typeDoc, setTypeDoc] = useState("");
  const [nameCondition, setNameCondition] = useState("");
  const [rolesSelected, setRolesSelected] = useState(JSON.parse(localStorage.getItem("roles")) || []);
  const [cleanroomSelected, setCleanroomSelected] = useState("0");
  const [loadingLogs, setLoadingLogs] = useState(false);
  const [loadingDocs, setLoadingDocs] = useState(false);
  const [activeTab, setActiveTab] = useState("logs");
 const lang = localStorage.getItem("lang") || "fr";

const localeMap = {
  fr: fr,
  en: enUS
};

  let abortControllerDocs = null;
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };

  useEffect(() => {
   
    setAllCleanrooms(JSON.parse(localStorage.getItem("allCleanrooms")) || []);
    const cleanroomUpdated = JSON.parse(localStorage.getItem("cleanroom")) || JSON.parse(localStorage.getItem("allCleanroom")) || [];
     if (currentOrg && cleanroomUpdated.length > 0) {
       axios.get(
        BACKEND_URL_PORTAIL + "api/getGroup/" + currentOrg,
        config
      ).then((response1)=> {
      setOrgName(response1.name);

      });
      //fetchDataLogs(currentOrg, type, startDate, endDate);
     } 
   
     let interval;
   
     if (shouldCheckInterval) {
       interval = setInterval(() => {
         const updatedOrg = localStorage.getItem("currentOrg");
         const updatedType = localStorage.getItem("type");
         const updatedUser = JSON.parse(localStorage.getItem("user")) || [];
         const cleanroomUpdated = JSON.parse(localStorage.getItem("cleanroom")) || JSON.parse(localStorage.getItem("allCleanroom")) || [];
         const types = JSON.parse(localStorage.getItem("types")) || [];
         // Vérification des conditions
         if (
           updatedOrg !== currentOrg ||
           updatedType !== type ||
           updatedUser.id !== userConnected.id ||
           (cleanroomUpdated.length == 0 ) ||
           types.length == 0
         ) {
           setCurrentOrg(updatedOrg);
           setType(updatedType);
           setUserConnected(updatedUser);
           fetchDataLogs(updatedOrg, updatedType, startDate, endDate);
           fetchDataDocs(updatedOrg, updatedType, startDate, endDate);
         } else {
           // Désactiver l'intervalle si toutes les conditions sont fausses
           setShouldCheckInterval(false);
           
         }
       }, 500);
     }
   
     return () => {
       if (interval) clearInterval(interval);
     };

   }, [currentOrg, type, shouldCheckInterval,localStorage.getItem("allCleanroom")]);

   useEffect(() => {
    if (activeTab === "logs" && dataStat.length === 0) {
    fetchDataLogs(currentOrg, type, startDate, endDate);
    fetchDataDocs(currentOrg, type, startDate, endDate);
    }
  }, [activeTab, type, startDate, endDate]);
  
   useEffect(() => {
    if (activeTab === "docs" && dataStatDoc.length === 0) {
      fetchDataDocs(currentOrg, type, startDate, endDate);
    }
  }, [activeTab,dataStat]); 

    useEffect(() => {
     
      if (currentOrg) {
        fetchDataLogs(currentOrg, type, startDate, endDate);
      }
    }, [currentOrg, type,startDate, endDate,localStorage.getItem("allCleanroom")]);

  const formatDateToYMD = (date) => {
    const d = new Date(date);
    return d.toISOString().split("T")[0];
  };

  const handlePresetChange = (e) => {
    
    const value = e.target.value;
    setPreset(value);

    const now = new Date();

    switch (value) {
      case "previousDay":
        const previousDay = new Date(now);
        previousDay.setDate(now.getDate() - 1);
        setStartDate(formatDateToYMD(previousDay));
        setEndDate(formatDateToYMD(previousDay));
        break;

      case "lastWeek":
        const lastWeekStart = new Date(now);
        lastWeekStart.setDate(now.getDate() - 7 - now.getDay());
        const lastWeekEnd = new Date(lastWeekStart);
        lastWeekEnd.setDate(lastWeekStart.getDate() + 6);
        setStartDate(formatDateToYMD(lastWeekStart));
        setEndDate(formatDateToYMD(lastWeekEnd));
        break;

      case "lastMonth":
        const lastMonthStart = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        const lastMonthEnd = new Date(now.getFullYear(), now.getMonth(), 0);
        setStartDate(formatDateToYMD(lastMonthStart));
        setEndDate(formatDateToYMD(lastMonthEnd));
        break;

      default:
        setStartDate(today);
        setEndDate(today);
        break;
    }
    setDataStat([]);
    setDataStatDoc([])
  };
  function getElementsBySanstraduction(data, sanstraduction) {
    return data.filter(
      item => item.Sanstraduction === "all" || item.Sanstraduction === sanstraduction
    );
  }

  const isAllZeroForDocs = dataStatDoc.length === 1 &&
  dataStatDoc.every(entry => {
    const stats = entry?.data?.readingLists_count_daily;
    return (
      (stats?.percentageCompletedQuizsInPeriod || 0) === 0 &&
      (stats?.percentageSuccededQuizsInPeriod || 0) === 0 &&
      (stats?.percentage || 0) === 0
    );
  });
  
  const fetchDataLogs = async (org, typ, start, end) => {
    setLoadingLogs(true);
    setDataStat([]);
    
    try {
      const cleanroomArray = JSON.parse(localStorage.getItem("cleanroom")) || JSON.parse(localStorage.getItem("allCleanroom")) || [];
      const types = JSON.parse(localStorage.getItem("types")) || [];
      const filteredTypes = types.filter((item) => item.Sanstraduction !== "all");
      const rolesArray = JSON.parse(localStorage.getItem("roles")) || [];
      const rolesString = rolesArray.length > 0 ? rolesArray.join(",") : "";
  
      let combinedData = [];
      axios.get(
        BACKEND_URL_PORTAIL + "api/getGroup/" + currentOrg,
        config
      ).then((response1)=> {
      setOrgName(response1.name);

      });
      if (types.length > 0) {
        if (typ === "all") {
          for (const t of filteredTypes) {
            for (const c of cleanroomArray) {
              const data = {
                startDate: start,
                endDate: end,
                clientId: org,
                type: t.Sanstraduction,
                teamArray: rolesString,
                cleanroom: c,
              };
              const response = await axios.post(`${BACKEND_URL_LOG}getLogsStatistics`, data, config);
              combinedData.push({ type: t, cleanroom: c, data: response });
            }
          }
        } else {
          for (const c of cleanroomArray) {
            const data = {
              startDate: start,
              endDate: end,
              clientId: org,
              type: typ,
              teamArray: rolesString,
              cleanroom: c,
            };
            const response = await axios.post(`${BACKEND_URL_LOG}getLogsStatistics`, data, config);
            combinedData.push({ type: typ, cleanroom: c, data: response });
          }
        }
      }
      console.log("data logs",combinedData)
      setDataStat(combinedData);
      setLoadingLogs(false);
    } catch (err) {
      console.error("Erreur lors de la récupération des données logs :", err);
      if (err === "Request failed with status code 401") {
        localStorage.clear();
        navigate("/login", { replace: true });
      } else {
        console.error(err);
      }
    }
  };
  const fetchDataDocs = async (org, typ, start, end) => {
    if (abortControllerDocs) {
      abortControllerDocs.abort();
    }
  
    abortControllerDocs = new AbortController();
    setLoadingDocs(true);
    setDataStatDoc([]);
  
    try {
      const types = JSON.parse(localStorage.getItem("types")) || [];
      const rolesArray = JSON.parse(localStorage.getItem("roles")) || [];
      const rolesString = rolesArray.length > 0 ? rolesArray.join(",") : "";
  
      let combinedDataDoc = [];
       if (typ === "all") {
        for (const t of types) {
          const dataDoc = {
            startDate: start,
            endDate: end,
            clientId: org,
            teamArray: rolesString,
            typeFilter: t.value,
          };
          const response = await axios.post(`${BACKEND_URL_DOC}getDocsStatistics`, dataDoc, {...config, signal: abortControllerDocs.signal});
          combinedDataDoc.push({ type: t, data: response });
        }
      } else {
        const typesDocSelected = getElementsBySanstraduction(types, typ);
        for (const td of typesDocSelected) {
          const dataDoc = {
            startDate: start,
            endDate: end,
            clientId: org,
            teamArray: rolesString,
            typeFilter: td.value,
          };
          const response = await axios.post(`${BACKEND_URL_DOC}getDocsStatistics`, dataDoc, {...config, signal: abortControllerDocs.signal});
          combinedDataDoc.push({ type: td, data: response });
        }
      }
      console.log("data docs",combinedDataDoc)
      setDataStatDoc(combinedDataDoc);
    } catch (err) {
      console.error("Erreur lors de la récupération des données docs :", err);
      if (err === "Request failed with status code 401") {
        localStorage.clear();
        navigate("/login", { replace: true });
      } else {
        console.error(err);
      }
    }
  
    setLoadingDocs(false);
  };
  const handleStartDateChange = (date) => {
  if (!date) return; // sécurité
  const newStartDate = formatDateToYMD(date);
  if (newStartDate <= endDate) {
    setStartDate(newStartDate);
  } else {
    alert("La date de début ne peut pas dépasser la date de fin.");
  }
  setDataStat([]);
  setDataStatDoc([]);
};

 const handleEndDateChange = (date) => {
  if (!date) return; // sécurité
  const newEndDate = formatDateToYMD(date);
  if (newEndDate >= startDate) {
    setEndDate(newEndDate);
  } else {
    alert("La date de fin ne peut pas être antérieure à la date de début.");
  }
  setDataStat([]);
  setDataStatDoc([]);
};

  const formatPercentage = (value) => {

    if (value === undefined || value === null) return "0.00";
  
    const formattedValue = parseFloat(value).toFixed(2);
    return formattedValue.endsWith(".00") ? parseInt(formattedValue, 10).toString() : formattedValue;
  };
const handleOpen = (typeSelected,name,cleanroomSelected) => {
  setTypeDetail(typeSelected)
  setNameCondition(name)
  setCleanroomSelected(cleanroomSelected)
  setOpen(true);
};
const handleOpenReadingList = (typeSelected,typeDoc) => {
  setTypeReadingList(typeSelected)
  setTypeDoc(typeDoc);
  setOpenReadingList(true);

};
const handleOpenQuizList = (typeSelected,typeDoc) => {
  setTypeQuizList(typeSelected)
  setTypeDoc(typeDoc);
  setOpenQuizList(true);

};

const handleClickCompleted = (entry, type, period, cleanroom) => {
  const basePeriod = (period === "customWeekly-notCompleted") 
    ? "custom_weekly" 
    : period.split("-")[0];

  if (entry.data?.[`logs_count_${basePeriod}`]?.percentage && entry.data?.[`logs_count_${basePeriod}`]?.percentage !== 0) {
    handleOpen(type == "all" ? entry.type.Sanstraduction : entry.type, period, cleanroom);
  }
};

const handleClickNotCompleted = (entry, type, period, cleanroom) => {
  const basePeriod = (period === "customWeekly-notCompleted") 
    ? "custom_weekly" 
    : period.split("-")[0];

  if ((entry.data?.[`logs_count_${basePeriod}`]?.percentage && entry.data?.[`logs_count_${basePeriod}`]?.percentage === 0) ||(entry.data?.[`logs_count_${basePeriod}`]?.data?.["@total"] != entry.data?.[`logs_count_${basePeriod}`]?.data?.["@completed"])) {
    handleOpen(type == "all" ? entry.type.Sanstraduction : entry.type, period, cleanroom);
  }
};
const isClickableCompleted = (entry, period) => {
  const basePeriod = period.split("-")[0];
  return entry.data?.[`logs_count_${basePeriod}`]?.percentage && entry.data?.[`logs_count_${basePeriod}`]?.percentage !== 0;
};
const isClickableNotCompleted = (entry, period) => {
  const basePeriod = period.split("-")[0];
  return (
    (entry.data?.[`logs_count_${basePeriod}`]?.percentage && entry.data?.[`logs_count_${basePeriod}`]?.percentage === 0) ||
    (entry.data?.[`logs_count_${basePeriod}`]?.data?.["@total"] !== entry.data?.[`logs_count_${basePeriod}`]?.data?.["@completed"])
  );
};
const isClickableRead = (entry) => {
  return entry.data?.readingLists_count_daily.percentage && entry.data?.readingLists_count_daily.percentage !== 0;
};
const isClickableNotRead = (entry) => {
  return 100-entry.data?.readingLists_count_daily.percentage && 100-entry.data?.readingLists_count_daily.percentage !== 0;
};
const isClickableQuizCompleted = (entry) => {
  return entry.data?.readingLists_count_daily.percentageCompletedQuizsInPeriod && entry.data?.readingLists_count_daily.percentageCompletedQuizsInPeriod !== 0;
};
const isClickableQuizNotCompleted = (entry) => {
  return 100-entry.data?.readingLists_count_daily.percentageCompletedQuizsInPeriod && 100-entry.data?.readingLists_count_daily.percentageCompletedQuizsInPeriod !== 0;
};
const isClickableQuizSuccess = (entry) => {
  return entry.data?.readingLists_count_daily.percentageSuccededQuizsInPeriod && entry.data?.readingLists_count_daily.percentageSuccededQuizsInPeriod !== 0;
};

const handleClose = () => {
  setNameCondition("")
  setTypeDetail("")
  setCleanroomSelected("0")
  setOpen(false);
};
const handleCloseReadingList = () => {
  setTypeReadingList("")
  setOpenReadingList(false);
};
const handleCloseQuizList = () => {
  setTypeQuizList("")
  setOpenQuizList(false);
};
const handleClickRL = (entry, type) => {
  if (entry.data?.readingLists_count_daily.percentage && entry.data?.readingLists_count_daily?.percentage !== 0) {
    handleOpenReadingList(type,entry.type);
  }
};

const handleClickNotReadRL = (entry, type) => {
  if (entry.data?.readingLists_count_daily.data?.["@total"]&& entry.data?.readingLists_count_daily.data?.["@total"] > 0 && entry.data?.readingLists_count_daily?.percentage!=100) {
    handleOpenReadingList(type,entry.type);
  }
};
const handleClickQuizCompleted = (entry, type) => {
   if (entry.data?.readingLists_count_daily.percentageCompletedQuizsInPeriod && entry.data?.readingLists_count_daily?.percentageCompletedQuizsInPeriod !== 0) {
    handleOpenQuizList(type,entry.type);
  } 
};
const handleClickQuizNotCompleted = (entry, type) => {
  if (entry.data?.readingLists_count_daily.percentageCompletedQuizsInPeriod && 100-entry.data?.readingLists_count_daily?.percentageCompletedQuizsInPeriod !== 0) {
    handleOpenQuizList(type,entry.type);
  }
};
const handleClickQuizSuccess = (entry, type) => {
  if (entry.data?.readingLists_count_daily.percentageSuccededQuizsInPeriod && 100-entry.data?.readingLists_count_daily?.percentageSuccededQuizsInPeriod !== 0) {
    handleOpenQuizList(type,entry.type);
  }
};

const isDisabled = dataStat.length > 0 && (dataStatDoc.length > 0 && !isAllZeroForDocs);
console.log(dataStat.length)
console.log(!isAllZeroForDocs)
console.log(isDisabled)
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
         <Card className="card-bordred custom-card">
          <Row className="mb-3">
            <Col md={12}>
              <Label for="preset">{t("selectDateRange")}</Label>
              <Input type="select" id="preset" value={preset} onChange={handlePresetChange} disabled={!isDisabled}>
                <option value="">{t("Select")}</option>
                <option value="previousDay">{t("previousDay")}</option>
                <option value="lastWeek">{t("lastWeek")}</option>
                <option value="lastMonth">{t("lastMonth")}</option>
              </Input>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup className="custom-datepicker">
                <Label for="startDate">{t("startDate")}</Label>
                <DatePicker
                className="form-control dateStyle"
                  selected={startDate ? new Date(startDate) : null}
                  onChange={handleStartDateChange}
                  locale={localeMap[lang]}
                  dateFormat="dd/MM/yyyy"
                  maxDate={endDate ? new Date(endDate) : null}
                  disabled={preset !== "" || !isDisabled}
                  popperPlacement="bottom-start"   // pour forcer l’affichage sous le champ
                    popperModifiers={[
                      {
                        name: 'preventOverflow',
                        options: {
                          boundary: 'viewport'  // limite au viewport
                        }
                      }
                    ]}
                    portalId="root-portal"
                />
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup className="custom-datepicker">
                <Label for="endDate">{t("endDate")}</Label>
                <DatePicker
                    className="form-control"
                    selected={endDate ? new Date(endDate) : null}
                    onChange={handleEndDateChange}
                    locale={localeMap[lang]}
                    dateFormat="dd/MM/yyyy"
                    minDate={startDate ? new Date(startDate) : null}
                    disabled={preset !== "" || !isDisabled}
                    popperPlacement="bottom-start"   // pour forcer l’affichage sous le champ
                    popperModifiers={[
                      {
                        name: 'preventOverflow',
                        options: {
                          boundary: 'viewport'  // limite au viewport
                        }
                      }
                    ]}
                    portalId="root-portal"
                  />
              </FormGroup>
            </Col>
          </Row>

            <Row>
              <Col md={6}>
                <Nav horizental className="nav-tabs-custom">
                  <NavItem>
                    <NavLink className={classnames("nav-link-custom", { active: activeTab === "logs" })} onClick={() => setActiveTab("logs")}>
                      {t("StatQuessLogs")}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink className={classnames("nav-link-custom", { active: activeTab === "docs" })} onClick={() => setActiveTab("docs")} style={{marginLeft:"-6%"}}>
                      {t("StatQuessDocs")}
                    </NavLink>
                  </NavItem>
                </Nav>
              </Col>
              <Col md={12}>
                <TabContent activeTab={activeTab} className="tab-content-container">
                  <TabPane tabId="logs">
                    {loadingLogs ? (<div className="text-center mt-5">
                          <Spinner
                        color="primary"
                        style={{
                          height: '3rem',
                          width: '3rem'
                        }}
                      >
                        Loading...
                          </Spinner>
                          <div className="text-center mt-2">
                        {t("loading...")}
                        </div>
                        </div>) :dataStat.length > 0 ? (
                        <div className="table-container">
                          <table className="mt-2 fixed-header white-bordered-table">
                            <thead>
                              <tr>
                                <th rowSpan="4" className="text-center table-header">
                                  {t("organisation")}
                                </th>
                                <th rowSpan="4" className="text-center table-header">
                                  {t("Type")}
                                </th>
                                
                                <th rowSpan="4" className="text-center table-header">
                                  {t("cleanroom")}
                                </th>
                                <th rowSpan="4" className="text-center table-header">
                                  {t("responsible")}
                                </th>
                                <th colSpan="15" className="text-center table-header">
                                  {t("logs")}
                                </th>
                              </tr>
                              <tr>
                                <th colSpan="3" className="text-center table-headerType">
                                  {t("quotidien")}
                                </th>
                                <th colSpan="3" className="text-center table-headerType">
                                  {t("hebdomadaire")}
                                </th>
                                <th colSpan="3" className="text-center table-headerType">
                                  {t("semaine")}
                                </th>
                                <th colSpan="3" className="text-center table-headerType">
                                  {t("customWeekly")}
                                </th>
                                <th colSpan="3" className="text-center table-headerType">
                                  {t("mensuel")}
                                </th>
                              </tr>
                              <tr>
                              <th colSpan="2" className="table-headerType">{t("Completed")}</th>
                              <th rowSpan="2" className="table-headerType">{t("NotCompleted")}</th>

                              <th colSpan="2" className="table-headerType">{t("Completed")}</th>
                              <th rowSpan="2" className="table-headerType">{t("NotCompleted")}</th>

                              <th colSpan="2" className="table-headerType">{t("Completed")}</th>
                              <th rowSpan="2" className="table-headerType">{t("NotCompleted")}</th>

                              <th colSpan="2" className="table-headerType">{t("Completed")}</th>
                              <th rowSpan="2" className="table-headerType">{t("NotCompleted")}</th>

                              <th colSpan="2" className="table-headerType">{t("Completed")}</th>
                              <th rowSpan="2" className="table-headerType">{t("NotCompleted")}</th>

                              </tr>

                              <tr>
                              <th className="table-headerType">{t("onTime")}</th>
                              <th className="table-headerType">{t("total")}</th>
                            

                              <th className="table-headerType">{t("onTime")}</th>
                              <th className="table-headerType">{t("total")}</th>

                              <th className="table-headerType">{t("onTime")}</th>
                              <th className="table-headerType">{t("total")}</th>

                              <th className="table-headerType">{t("onTime")}</th>
                              <th className="table-headerType">{t("total")}</th>

                              <th className="table-headerType">{t("onTime")}</th>
                              <th className="table-headerType">{t("total")}</th>

                              </tr>
                            </thead>
                            <tbody>
                            {dataStat.length > 0 && dataStat.map((entry, index) => (
                              (type === "all" && (!entry.type || !entry.type.Sanstraduction))
                              ? null
                              :
                              (<tr className="row-el" key={`${entry.type?.Sanstraduction}-${entry.cleanroom}`}>
                                <td>{orgName || t("Unknown Organization")}</td>
                                <td>
                                  {type === "all"
                                    ? entry.type?.Sanstraduction 
                                      ? t(entry.type.Sanstraduction)
                                      : t("Unknown Type")
                                    : t(type)}
                                </td>
                                <td>
                                  {entry.cleanroom == 0
                                    ? t("withOutCleanroom")
                                    : allCleanrooms.find(cleanroom => cleanroom.id === entry.cleanroom)?.name || t("N/A")}
                                </td>   
                                <td>
                                  {entry.cleanroom == 0
                                    ? t("N/A")
                                    : allCleanrooms
                                        .filter(cleanroom => entry.cleanroom.includes(cleanroom.id.toString())) // Ensure `id` matches type (string vs number)
                                        .map(cleanroom => cleanroom.responsable?.name)
                                        .filter(name => name) 
                                        || t("N/A")}
                                </td>
                                         

                                {/* Quotidien */}
                                <td>{formatPercentage(entry.data?.completed_and_in_time_daily?.percentage || 0)}%</td>

                                <td onClick={() => handleClickCompleted(entry,type,"daily-completed",entry.cleanroom)}  className={isClickableCompleted(entry, "daily-completed") ? "logPointer" : ""}>
                                  <span className={entry.data?.logs_count_daily?.data?.["@total"] === 0 && entry.data?.logs_count_daily?.data?.["@completed"] === 0
                                    ? "" // Pas de classe si les valeurs sont égales à 0
                                    : entry.data?.logs_count_daily?.percentage === 100 ? 'circle-value cell-green' : 'circle-value cell-red'}>
                                    {entry.data?.logs_count_daily?.data?.["@total"] === 0 && entry.data?.logs_count_daily?.data?.["@completed"] === 0
                                      ? 0
                                      : formatPercentage(entry.data?.logs_count_daily?.percentage || 0)}%
                                  </span>
                                </td> 

                                <td onClick={() => handleClickNotCompleted(entry,type,"daily-notCompleted",entry.cleanroom)} className={isClickableNotCompleted(entry, "daily-notCompleted") ? "logPointer" : ""}>
                                  <span className={entry.data?.logs_count_daily?.data?.["@total"] === 0 && entry.data?.logs_count_daily?.data?.["@completed"] === 0
                                    ? "" 
                                    : entry.data?.logs_count_daily?.percentage < 100 ? 'circle-value cell-red' : 'circle-value cell-green'}>
                                    {entry.data?.logs_count_daily?.data?.["@total"] === 0 && entry.data?.logs_count_daily?.data?.["@completed"] === 0
                                      ? 0
                                      : formatPercentage(100 - (entry.data?.logs_count_daily?.percentage || 0))}%
                                  </span>
                                </td>

                                {/* Hebdomadaire */}
                                <td>{formatPercentage(entry.data?.completed_and_in_time_hebdomadaire?.percentage || 0)}%</td>

                                <td onClick={() => handleClickCompleted(entry,type,"hebdomadaire-completed",entry.cleanroom)} className={isClickableCompleted(entry, "hebdomadaire-completed") ? "logPointer" : ""}>
                                  <span className={entry.data?.logs_count_hebdomadaire?.data?.["@total"] === 0 && entry.data?.logs_count_hebdomadaire?.data?.["@completed"] === 0
                                    ? "" // Pas de classe si les valeurs sont égales à 0
                                    : entry.data?.logs_count_hebdomadaire?.percentage === 100 ? 'circle-value cell-green' : 'circle-value cell-red'}>
                                    {entry.data?.logs_count_hebdomadaire?.data?.["@total"] === 0 && entry.data?.logs_count_hebdomadaire?.data?.["@completed"] === 0
                                      ? 0
                                      : formatPercentage(entry.data?.logs_count_hebdomadaire?.percentage || 0)}%
                                  </span>
                                </td>

                                <td onClick={() => handleClickNotCompleted(entry,type,"hebdomadaire-notCompleted",entry.cleanroom)} className={isClickableNotCompleted(entry, "hebdomadaire-notCompleted") ? "logPointer" : ""}>
                                  <span className={entry.data?.logs_count_hebdomadaire?.data?.["@total"] === 0 && entry.data?.logs_count_hebdomadaire?.data?.["@completed"] === 0
                                    ? "" // Pas de classe si les valeurs sont égales à 0
                                    : entry.data?.logs_count_hebdomadaire?.percentage < 100 ? 'circle-value cell-red' : 'circle-value cell-green'}>
                                    {entry.data?.logs_count_hebdomadaire?.data?.["@total"] === 0 && entry.data?.logs_count_hebdomadaire?.data?.["@completed"] === 0
                                      ? 0
                                      :formatPercentage( 100 - (entry.data?.logs_count_hebdomadaire?.percentage || 0))}%
                                  </span>
                                </td>

                                {/* Semaine */}
                                <td>{formatPercentage(entry.data?.completed_and_in_time_semaine?.percentage || 0)}%</td>

                                <td onClick={() => handleClickCompleted(entry,type,"semaine-completed",entry.cleanroom)}  className={isClickableCompleted(entry, "semaine-completed") ? "logPointer" : ""}>
                                  <span className={entry.data?.logs_count_semaine?.data?.["@total"] === 0 && entry.data?.logs_count_semaine?.data?.["@completed"] === 0
                                    ? "" // Pas de classe si les valeurs sont égales à 0
                                    : entry.data?.logs_count_semaine?.percentage === 100 ? 'circle-value cell-green' : 'circle-value cell-red'}>
                                    {entry.data?.logs_count_semaine?.data?.["@total"] === 0 && entry.data?.logs_count_semaine?.data?.["@completed"] === 0
                                      ? 0
                                      : formatPercentage(entry.data?.logs_count_semaine?.percentage || 0)}%
                                  </span>
                                </td>

                                <td onClick={() => handleClickNotCompleted(entry,type,"semaine-notCompleted",entry.cleanroom)} className={isClickableNotCompleted(entry, "semaine-notCompleted") ? "logPointer" : ""}>
                                  <span className={entry.data?.logs_count_semaine?.data?.["@total"] === 0 && entry.data?.logs_count_semaine?.data?.["@completed"] === 0
                                    ? "" // Pas de classe si les valeurs sont égales à 0
                                    : entry.data?.logs_count_semaine?.percentage < 100 ? 'circle-value cell-red' : 'circle-value cell-green'}>
                                    {entry.data?.logs_count_semaine?.data?.["@total"] === 0 && entry.data?.logs_count_semaine?.data?.["@completed"] === 0
                                      ? 0
                                      : formatPercentage(100 - (entry.data?.logs_count_semaine?.percentage || 0))}%
                                  </span>
                                </td>

                                {/* Semaine personnalisé */}
                                <td>{formatPercentage(entry.data?.completed_and_in_time_custom_weekly?.percentage || 0)}%</td>

                                <td onClick={() => handleClickCompleted(entry,type,"customWeekly-completed",entry.cleanroom)}  className={isClickableCompleted(entry, "custom_weekly-completed") ? "logPointer" : ""}>
                                  <span className={entry.data?.logs_count_custom_weekly?.data?.["@total"] === 0 && entry.data?.logs_count_custom_weekly?.data?.["@completed"] === 0
                                    ? "" // Pas de classe si les valeurs sont égales à 0
                                    : entry.data?.logs_count_custom_weekly?.percentage === 100 ? 'circle-value cell-green' : 'circle-value cell-red'}>
                                    {entry.data?.logs_count_custom_weekly?.data?.["@total"] === 0 && entry.data?.logs_count_custom_weekly?.data?.["@completed"] === 0
                                      ? 0
                                      : formatPercentage(entry.data?.logs_count_custom_weekly?.percentage || 0)}%
                                  </span>
                                </td>

                                <td onClick={() => handleClickNotCompleted(entry,type,"customWeekly-notCompleted",entry.cleanroom)} className={isClickableNotCompleted(entry, "custom_weekly-notCompleted") ? "logPointer" : ""}>
                                  <span className={entry.data?.logs_count_custom_weekly?.data?.["@total"] === 0 && entry.data?.logs_count_custom_weekly?.data?.["@completed"] === 0
                                    ? "" // Pas de classe si les valeurs sont égales à 0
                                    : entry.data?.logs_count_custom_weekly?.percentage < 100 ? 'circle-value cell-red' : 'circle-value cell-green'}>
                                    {entry.data?.logs_count_custom_weekly?.data?.["@total"] === 0 && entry.data?.logs_count_custom_weekly?.data?.["@completed"] === 0
                                      ? 0
                                      : formatPercentage(100 - (entry.data?.logs_count_custom_weekly?.percentage || 0))}%
                                  </span>
                                </td>

                                {/* Mensuel */}
                                <td>{formatPercentage(entry.data?.completed_and_in_time_monthly?.percentage || 0)}%</td>

                                <td onClick={() => handleClickCompleted(entry,type,"monthly-completed",entry.cleanroom)}  className={isClickableCompleted(entry, "monthly-completed") ? "logPointer" : ""}>
                                  <span className={entry.data?.logs_count_monthly?.data?.["@total"] === 0 && entry.data?.logs_count_monthly?.data?.["@completed"] === 0
                                    ? "" // Pas de classe si les valeurs sont égales à 0
                                    : entry.data?.logs_count_monthly?.percentage === 100 ? 'circle-value cell-green' : 'circle-value cell-red'}>
                                    {entry.data?.logs_count_monthly?.data?.["@total"] === 0 && entry.data?.logs_count_monthly?.data?.["@completed"] === 0
                                      ? 0
                                      : formatPercentage(entry.data?.logs_count_monthly?.percentage || 0)}% 
                                  </span>
                                </td>

                                <td onClick={() => handleClickNotCompleted(entry,type,"monthly-notCompleted",entry.cleanroom)} className={isClickableNotCompleted(entry, "monthly-notCompleted") ? "logPointer" : ""}>
                                  <span className={entry.data?.logs_count_monthly?.data?.["@total"] === 0 && entry.data?.logs_count_monthly?.data?.["@completed"] === 0
                                    ? "" // Pas de classe si les valeurs sont égales à 0
                                    : entry.data?.logs_count_monthly?.percentage < 100 ? 'circle-value cell-red' : 'circle-value cell-green'}>
                                    {entry.data?.logs_count_monthly?.data?.["@total"] === 0 && entry.data?.logs_count_monthly?.data?.["@completed"] === 0
                                      ? 0
                                      : formatPercentage(100 - (entry.data?.logs_count_monthly?.percentage || 0))}%
                                  </span>
                                </td>
                                
                              </tr>)
                            ))}
                            </tbody>
                          </table>
                        </div> ) : (
                        
                        <div className="text-center mt-4 text-muted">
                          {t("noDataLogs")}
                        </div>
                      )
                    }                   
                  </TabPane>
                  <TabPane tabId="docs">
                  {loadingDocs ? (<div className="text-center mt-5">
                        <Spinner
                      color="primary"
                      style={{
                        height: '3rem',
                        width: '3rem'
                      }}
                    >
                      Loading...
                        </Spinner>
                        <div className="text-center mt-2">
                      {t("loading...")}
                      </div>
                      </div> ) : dataStatDoc.length > 0 && !isAllZeroForDocs ? (
                      <div className="table-container">
                        <table className="mt-2 fixed-header white-bordered-table">
                          <thead>
                            <tr>
                              <th rowSpan="2" className="text-center table-header">
                                {t("organisation")}
                              </th>
                            
                              <th rowSpan="2" className="text-center table-header">
                                {t("responsible")}
                              </th>
                              <th rowSpan="4" className="text-center table-header">
                                {t("Type")}
                              </th>
                              {/* <th rowSpan="2" className="text-center table-header">
                                {t("Cleanroom")}
                              </th> */}
                              <th colSpan="12" className="text-center table-header">
                                {t("readingList")}
                              </th>
                            </tr>
                            
                            <tr>
                              <th className="table-headerType">{t("read")}</th>
                              <th className="table-headerType">{t("notRead")}</th>
                              <th className="table-headerType">{t("quizCompleted")}</th>
                              <th className="table-headerType">{t("quizNotCompleted")}</th>
                              <th className="table-headerType">{t("quizSuccess")}</th>
                            </tr>
                          </thead>
                          <tbody>
                          {dataStatDoc.length > 0 &&dataStatDoc.map((entry, index) => (
                            <tr
                              className="row-el"
                              key={`${entry.type?.Sanstraduction}-${entry.cleanroom}`}
                            >
                              <td>{orgName || t("Unknown Organization")}</td>

                              <td>
                                {userConnected?.firstname || t("Unknown")} {userConnected?.lastname || ""}
                              </td>
                              <td>{(() => {
                                const sanstrad = entry?.type?.Sanstraduction;
                                
                                  return sanstrad === "all" ? t("withOutType") : t(sanstrad);
                                
                              })()}
                              </td>
                              {/* readingList */}
                              <td  onClick={() => handleClickRL(entry,"completed")} className={isClickableRead(entry) ? "logPointer" : ""}>
                                <span
                                  className={
                                    entry.data?.readingLists_count_daily?.data?.["@total"] === 0 &&
                                    entry.data?.readingLists_count_daily?.data?.["@completed"] === 0
                                      ? ""
                                      : entry.data?.readingLists_count_daily?.percentage < 50
                                      ? "circle-value cell-red"
                                      : entry.data?.readingLists_count_daily?.percentage < 80
                                      ? "circle-value cell-yellow"
                                      : "circle-value cell-green"
                                  }
                                >
                                  {entry.data?.readingLists_count_daily?.data?.["@total"] === 0 &&
                                  entry.data?.readingLists_count_daily?.data?.["@completed"] === 0
                                    ? 0
                                    : entry.data?.readingLists_count_daily?.percentage || 0}%
                                </span>
                              </td>

                              <td onClick={() => handleClickNotReadRL(entry,"notCompleted")} className={isClickableNotRead(entry) ? "logPointer" : ""}>
                              <span
                                  className={
                                    entry.data?.readingLists_count_daily?.data?.["@total"] === 0 &&
                                    entry.data?.readingLists_count_daily?.data?.["@completed"] === 0
                                      ? ""
                                      : 100-(entry.data?.readingLists_count_daily?.percentage) < 50
                                      ? "circle-value cell-red"
                                      : 100-(entry.data?.readingLists_count_daily?.percentage) < 80
                                      ? "circle-value cell-yellow"
                                      : "circle-value cell-green"
                                  }
                                >
                                  {entry.data?.readingLists_count_daily?.data?.["@total"] === 0 &&
                                  entry.data?.readingLists_count_daily?.data?.["@completed"] === 0
                                    ? 0
                                    : 100 - (entry.data?.readingLists_count_daily?.percentage || 0)}%
                                </span>
                              </td>
                              {/* percentageCompletedQuizsInPeriod */}
                              <td onClick={() => handleClickQuizCompleted(entry,"completed")}  className={isClickableQuizCompleted(entry) ? "logPointer" : ""}>
                                <span
                                  className={
                                    entry.data?.readingLists_count_daily?.data?.["@quizs"] === 0
                                      ? ""
                                      : entry.data?.readingLists_count_daily?.percentageCompletedQuizsInPeriod < 50
                                      ? "circle-value cell-red"
                                      : entry.data?.readingLists_count_daily?.percentageCompletedQuizsInPeriod < 80
                                      ? "circle-value cell-yellow"
                                      : "circle-value cell-green"
                                  }
                                >
                                  {entry.data?.readingLists_count_daily?.percentageCompletedQuizsInPeriod || 0}%
                                </span>
                              </td>

                              {/* 100 - percentageCompletedQuizsInPeriod */}
                              <td onClick={() => handleClickQuizNotCompleted(entry,"notCompleted")} className={isClickableQuizNotCompleted(entry) ? "logPointer" : ""}>
                              <span
                                  className={
                                    entry.data?.readingLists_count_daily?.data?.["@quizs"] === 0
                                      ? ""
                                      : 100-(entry.data?.readingLists_count_daily?.percentageCompletedQuizsInPeriod) < 50
                                      ? "circle-value cell-red"
                                      :100-( entry.data?.readingLists_count_daily?.percentageCompletedQuizsInPeriod) < 80
                                      ? "circle-value cell-yellow"
                                      : "circle-value cell-green"
                                  }
                                >
                                   {entry.data?.readingLists_count_daily?.data?.["@quizs"] === 0
                                    ? 0
                                    :100 - (entry.data?.readingLists_count_daily?.percentageCompletedQuizsInPeriod || 0)}%
                                
                                </span>
                              </td>

                              {/* percentageSuccededQuizsInPeriod */}
                              <td onClick={() => handleClickQuizSuccess(entry,"succeded")}  className={isClickableQuizSuccess(entry) ? "logPointer" : ""}>
                                <span
                                  className={
                                    entry.data?.readingLists_count_daily?.data?.["@quizs"] === 0
                                      ? ""
                                      : entry.data?.readingLists_count_daily?.percentageSuccededQuizsInPeriod < 50
                                      ? "circle-value cell-red"
                                      : entry.data?.readingLists_count_daily?.percentageSuccededQuizsInPeriod < 80
                                      ? "circle-value cell-yellow"
                                      : "circle-value cell-green"
                                  }
                                >
                                  {entry.data?.readingLists_count_daily?.percentageSuccededQuizsInPeriod || 0}%
                                </span>
                              </td>
                            </tr>
                          ))}

                          </tbody>
                        </table>
                      </div>
                   ) : (
                      
                      <div className="text-center mt-4 text-muted">
                        {t("noDataDocs")}
                      </div>
                    )}
                  </TabPane>
                </TabContent>
              </Col>
            </Row>
              </Card>
            
        </Container>
        {open && <ListLogs  open={open} onClose={handleClose} name={nameCondition} startDate={startDate} endDate={endDate} groupId={currentOrg} type={typeDetail} teamArray={rolesSelected.length > 0 ? rolesSelected.join(",") : ""} cleanroom={cleanroomSelected}/>}
        {openReadingList && <ReadingList  openReadingList={openReadingList} onCloseReadingList={handleCloseReadingList} startDate={startDate} endDate={endDate} groupId={currentOrg} type={typeReadingList} typeDoc={typeDoc} teamArray={rolesSelected.length > 0 ? rolesSelected.join(",") : ""} cleanroom={cleanroomSelected} />}
        {openQuizList && <QuizList  openQuizList={openQuizList} onCloseQuizList={handleCloseQuizList} startDate={startDate} endDate={endDate} groupId={currentOrg} type={typeQuizList} typeDoc={typeDoc} teamArray={rolesSelected.length > 0 ? rolesSelected.join(",") : ""} cleanroom={cleanroomSelected} />}
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
